import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { replacePlaceholders } from '../../../../../utils/replacers'
import { fsExcludeClass, isExcludedIdentifier } from '../../../../../utils/fsExclude'

const LinkCell = ({ column, value, row }) => {
  const cn = isExcludedIdentifier(column.id) ? fsExcludeClass : undefined
  const toUrl = useMemo(() => replacePlaceholders(column.to, row.original), [column.to, row.original])

  return (
    <Link className={cn} to={toUrl}>{value}</Link>
  )
}

LinkCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.object,
  column: PropTypes.shape({
    id: PropTypes.string,
    header: PropTypes.string,
    to: PropTypes.string
  })
}

export default LinkCell
